// projectFee.js — total-fee computation shared with the project edit modal.
//
// This MUST stay identical to calculateTotalFee in ManageProjectsPage.jsx: the
// edit modal creates a fee-revision record (consumed by the Invoices page and
// fee tracking) whenever this total changes. Any other surface that edits a
// fee-affecting field — the base fee (budget), the retainer, or the misc fee
// scopes — has to compute the same total and record the same revision, or the
// fee history the invoicing relies on drifts out of sync.
//
// Total fee = base fee + active retainer (monthly × months) + Σ misc fee scopes.

export function calculateTotalFee(p) {
  if (!p) return 0;
  const baseFee = p.budget || 0;
  const rc = p.retainerConfig || { monthlyAmount: 0, totalMonths: 12, status: 'inactive' };
  const ccRetainer = rc.status === 'active'
    ? (rc.monthlyAmount || 0) * (rc.totalMonths || 12)
    : 0;
  const miscFee = (Array.isArray(p.miscFeeScopes) ? p.miscFeeScopes : [])
    .reduce((sum, s) => sum + (Number(s.amount) || 0), 0);
  return baseFee + ccRetainer + miscFee;
}
